import React from "react";
import styled from "styled-components";

export default styled.button`
    background: #5562c0 !important;
    text-align: center;
    padding: 14px 21px;
    color: white;
    border: 0;
    cursor: pointer;
    font-weight: 700;
    font-size: 20px;
    line-height: 17px;
    display: inline-block;
    float: left;

    &.right-align {
        float: right;
        margin-top: -13px;
    }

    &.outline {
        margin-right: 15px;
        background: white !important;
        border: 1px solid #5562c0 !important;
        color: #5562c0 !important;
        box-sizing: border-box;
        height: 45px;
    }

    &:hover {
        box-shadow: 5px 5px 25px #5562c0;
    }

    i {
        margin-left: 19px;
        font-size: 17px;
    }

    &.orange {
        background: #ED6D5F !important;

        &:hover {
            box-shadow: 5px 5px 25px #ED6D5F;
        }
    }

    display: ${(props) => (props.hidden ? "none" : "block")};
`;
